/**
 * @param {*} value
 * @returns {string|undefined}
 */
function ssn (value) {
  if (!value) return

  let val = value
    .toString()
    .toUpperCase()
    .replace(/[^A-Z0-9-+]/g, '')

  if (val.length > 11) {
    val = val.substr(0, 11)
  }

  return val
}

module.exports = { ssn }
